import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Mail, MessageCircle, Smartphone } from 'lucide-react';
import { InteriorSlide, SlideHeader } from './SlideShell';
import type { SlideProps } from './SlideShell';
export function Slide03Background({
  index
}: SlideProps) {
  return <InteriorSlide data-id="element-73">
      <SlideHeader eyebrow="What You Told Us" data-id="element-74">
        "I leave you to flow."
      </SlideHeader>

      <div className="flex-1 flex flex-col lg:flex-row items-center gap-12 lg:gap-20 max-w-6xl mx-auto w-full" data-id="element-75">
        {/* Left text content */}
        <div className="flex-1 space-y-8" data-id="element-76">
          {["The content is good. The reach isn't.", "QR codes are working. Email isn't — HCPs in West Africa don't use professional email.", 'WhatsApp is the channel, but compliance is a grey area.', 'You are managing four brands across multiple countries: Breast Cancer, MS, Ophthalmology, Hemophilia.', 'You need a partner, not a content vendor.'].map((point, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.3 + i * 0.15,
          duration: 0.5
        }} className="flex items-start gap-4" data-id="element-77">
              <div className="mt-1.5 h-2 w-2 rounded-full bg-[var(--brand)] flex-shrink-0" data-id="element-78" />
              <p className="text-[clamp(1.1rem,1.4vw,1.3rem)] text-[var(--fg)] font-medium leading-relaxed" data-id="element-79">
                {point}
              </p>
            </motion.div>)}
        </div>

        {/* Right visual comparison */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.6,
        duration: 0.7
      }} className="flex-1 w-full relative rounded-3xl overflow-hidden shadow-2xl border-8 border-white min-h-[400px]" data-id="element-80">
          <img src="https://images.unsplash.com/photo-1666214277657-e60f05c40b04?w=1200&q=80" alt="African clinician using a mobile phone in a clinical setting" className="absolute inset-0 w-full h-full object-cover" data-id="element-81" />
          <div className="absolute inset-0 bg-gradient-to-t from-[var(--fg)]/90 via-[var(--fg)]/40 to-transparent" data-id="element-82" />

          <div className="absolute bottom-0 left-0 right-0 p-8 text-center space-y-6" data-id="element-83">
            <h3 className="text-2xl font-bold text-white" data-id="element-84">
              This is exactly what Snakker does for GSK Africa in Nigeria and
              Kenya.
            </h3>
            <div className="flex justify-center flex-wrap gap-3" data-id="element-85">
              <span className="px-4 py-2 bg-white/20 backdrop-blur-md rounded-full text-sm font-bold text-white border border-white/30 shadow-sm" data-id="element-86">
                Low cost
              </span>
              <span className="px-4 py-2 bg-white/20 backdrop-blur-md rounded-full text-sm font-bold text-white border border-white/30 shadow-sm" data-id="element-87">
                High impact
              </span>
              <span className="px-4 py-2 bg-[var(--brand)] rounded-full text-sm font-bold text-white shadow-sm" data-id="element-88">
                Full execution
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </InteriorSlide>;
}